import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BooleanFilterPipe } from './boolean-filter.pipe';
import { NameFilterPipe } from './name-filter.pipe';
import { OrderByPipe } from './order-by.pipe';
import { TranslatePipe } from './translate.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    FormsModule, NameFilterPipe, OrderByPipe, TranslatePipe, BooleanFilterPipe,
  ],
  declarations: [NameFilterPipe, OrderByPipe, TranslatePipe, BooleanFilterPipe,]
})
export class SharedModule { }
